import type { Messages } from './en.ts';

export const pl: Messages = {
  'app.tagline': 'Cyfrowa plomba na stanie kontenera przy każdym przekazaniu',
  'app.language': 'Language: English',
  'nav.label': 'Główne',
  'nav.handovers': 'Przekazania',
  'nav.fleet': 'Kontenery',
  'nav.inspect': 'Oględziny',
  'app.openSource': 'Plomba to otwarte oprogramowanie (Apache-2.0):',

  'common.retry': 'Spróbuj ponownie',
  'common.cancel': 'Anuluj',
  'common.save': 'Zapisz',
  'common.back': 'Wstecz',
  'common.loading': 'Ładowanie…',
  'common.error': 'Coś poszło nie tak',
  'common.offline':
    'Brak połączenia. Twoja praca jest bezpieczna; spróbuj ponownie po odzyskaniu sieci.',

  'intro.identify': 'Skieruj telefon na drzwi: numer kontenera zostanie odczytany i zweryfikowany.',
  'intro.record': 'Sfotografuj każdą ścianę albo nagraj jeden obchód kontenera.',
  'intro.confirm':
    'Uszkodzenia z poprzedniego przekazania pojawiają się w tym samym miejscu. Potwierdź je i zapisz nowe.',
  'intro.seal':
    'Zaplombuj przekazanie: protokół, komunikat bramowy i odporna na zmiany historia, która podąża za kontenerem.',
  'profile.change': 'Zmień',
  'common.done': 'Gotowe',
  'intro.eyebrow': 'Jak działa Plomba',
  'home.greeting': 'Kontroler',
  'home.statOpen': 'Otwarte',
  'home.statSealedToday': 'Dziś zaplombowane',
  'home.statMarks': 'Uszkodzenia',
  'home.heroTitle': 'Oględziny kontenera',
  'home.heroText':
    'Odczytaj drzwi, sfotografuj lub nagraj obchód, potwierdź, co się zmieniło od poprzedniego przekazania, i zaplombuj protokół.',
  'fleet.eyebrow': 'Flota',
  'fleet.title': 'Kontenery',
  'fleet.intro': 'Wszystkie kontenery zapisane w tej instalacji, od ostatnio przekazanych.',
  'fleet.search': 'Kod właściciela lub numer',
  'fleet.none': 'Brak kontenerów. Zrób oględziny, aby rozpocząć historię.',
  'fleet.noMatch': 'Żaden kontener nie pasuje.',
  'fleet.handovers': 'przekazania: {count} · zaplombowane: {sealed}',
  'profile.title': 'Kontroler',
  'profile.name': 'Imię i nazwisko',
  'profile.place': 'Miejsce (terminal lub depot)',
  'profile.missing': 'Podaj imię i nazwisko oraz miejsce, aby zacząć.',

  'home.inspect': 'Sprawdź kontener',
  'home.try': 'Nie masz kontenera pod ręką? Zobacz go na przykładowym nagraniu',
  'home.open': 'Otwarte przekazania',
  'home.recent': 'Ostatnio zaplombowane',
  'home.none': 'Brak przekazań.',
  'home.install': 'Zainstaluj aplikację',
  'home.installIos': 'Aby zainstalować: stuknij Udostępnij, potem „Do ekranu początkowego”.',
  'home.photos': 'zdjęcia: {count}',
  'home.marks': 'uszkodzenia: {count}',

  'camera.take': 'Zrób zdjęcie',
  'camera.choose': 'Wybierz zdjęcie',
  'camera.denied': 'Aparat jest niedostępny. Możesz wybrać zdjęcie z galerii.',
  'camera.starting': 'Uruchamianie aparatu…',

  'samples.doors': 'Nie masz tu kontenera? Wypróbuj przykładowe zdjęcie drzwi',
  'samples.usePhoto': 'Użyj przykładowego zdjęcia',
  'samples.loadingPhoto': 'Ładowanie przykładowego zdjęcia…',
  'samples.credit': 'Przykładowe zdjęcie · {credit}',
  'samples.source': 'Źródło',
  'try.eyebrow': 'Wypróbuj Plombę',
  'try.title': 'Zobacz to, co kontroler',
  'try.intro':
    'Wybierz przykładowe nagranie. Obrys, ściany, siatka CEDEX i zapisane uszkodzenia podążają za kontenerem. Ten podgląd nie tworzy przekazania.',
  'try.handover': 'Wypróbuj przekazanie z przykładowymi zdjęciami',
  'try.noSamples': 'W tej instalacji nie ma jeszcze przykładowych nagrań.',
  'try.layers': 'Pokaż na nagraniu',
  'try.layer.outlineGrid': 'Obrys, ściany i siatka',
  'try.layer.damage': 'Nienaprawione uszkodzenia',
  'try.layer.information': 'Informacje o kontenerze',
  'try.noContainer':
    'To nagranie nie jest powiązane z kontenerem. Pokazuje obrys, ściany i siatkę.',
  'try.loadingHistory': 'Ładowanie paszportu uszkodzeń kontenera…',
  'try.sizeUnknown': 'Nieznany rozmiar i typ',
  'try.highCube': 'podwyższony',
  'try.lastHandover': 'Ostatnio: {place} · {direction} · {date}',
  'try.noHandovers': 'Brak zapisanych przekazań',
  'try.chainVerified': 'Zaplombowane zapisy zweryfikowane: {count}',
  'try.chainBroken': 'Przerwany łańcuch zapisów',
  'try.noSealed': 'Brak zaplombowanych zapisów',
  'try.firstRecorded': 'Pierwszy zapis: {place} · {date}',
  'try.originUnknown': 'Brak danych o pierwszym zapisie',
  'try.openDamage': 'Nienaprawione uszkodzenia w paszporcie: {count}',
  'containerType.general-purpose': 'ogólnego przeznaczenia',
  'containerType.ventilated': 'wentylowany',
  'containerType.bulk': 'do ładunków sypkich',
  'containerType.named-cargo': 'do ładunków specjalnych',
  'containerType.refrigerated': 'chłodniczy',
  'containerType.insulated': 'izolowany',
  'containerType.open-top': 'z otwartym dachem',
  'containerType.platform': 'platforma',
  'containerType.tank': 'zbiornikowy',
  'containerType.air-surface': 'lotniczo-lądowy',

  'identify.title': 'Identyfikacja kontenera',
  'identify.guide': 'Skadruj oznaczenia na drzwiach: numer kontenera i kod typu pod nim.',
  'identify.reading': 'Muse Spark odczytuje oznaczenia…',
  'identify.checking': 'Sprawdzanie cyfry kontrolnej ISO 6346',
  'identify.verified': 'Cyfra kontrolna poprawna',
  'identify.suggested': 'Sprawdź proponowany numer',
  'identify.readAs': 'Odczytano: {read}',
  'identify.tapToChoose': 'Stuknij numer widoczny na kontenerze albo wpisz go poniżej.',
  'identify.ambiguous': 'Wybierz numer widoczny na kontenerze',
  'identify.unreadable': 'Nie udało się odczytać poprawnego numeru',
  'identify.number': 'Numer kontenera',
  'identify.numberValid': 'Poprawny numer ISO 6346',
  'identify.numberExpected': 'Cyfra kontrolna powinna być {digit}',
  'identify.numberIncomplete': 'Kod właściciela, U/J/Z, sześć cyfr i cyfra kontrolna',
  'identify.sizeType': 'Kod wymiaru i typu',
  'identify.sizeTypeUnknown': 'Nieznany: przyjęto kontener 40 ft',
  'identify.seals': 'Plomby',
  'identify.hazards': 'Nalepki ADR/IMDG',
  'identify.confirm': 'Potwierdź kontener',
  'identify.retake': 'Powtórz zdjęcie',
  'identify.manual': 'Wpisz numer ręcznie',
  'identify.highlight': 'Wyróżnione znaki różnią się od odczytu.',

  'container.dimensions': '{length} × {width} × {height} m',
  'container.chainOk': 'Historia nienaruszona: zaplombowane przekazania: {count}',
  'container.chainEmpty': 'Brak zaplombowanych przekazań',
  'container.chainBroken': 'Historia zmieniona przy przekazaniu nr {index}',
  'container.continue': 'Kontynuuj otwarte przekazanie',
  'container.start': 'Rozpocznij przekazanie',
  'container.eyebrow': 'Kontener',
  'container.history': 'Historia przekazań',

  'start.direction': 'Kierunek',
  'start.in': 'Wjazd',
  'start.out': 'Wyjazd',
  'start.place': 'Miejsce',
  'start.checker': 'Kontroler',
  'start.handedOverBy': 'Przekazujący (przewoźnik, kierowca)',
  'start.receivedBy': 'Odbierający',
  'start.seals': 'Numery plomb, po przecinku',
  'start.submit': 'Rozpocznij przekazanie',

  'handover.in': 'Wjazd',
  'handover.out': 'Wyjazd',
  'handover.open': 'Otwarte',
  'handover.closed': 'Zaplombowane',
  'handover.faces': 'Ściany: {done} z {total}',
  'handover.coverage': 'Sekcje ze zdjęciem: {done} z {total}',
  'handover.sealWithGaps':
    'Bez zdjęcia: {gaps}. Zaplombować mimo to? Rekord odnotuje, że tych sekcji nie sprawdzono.',
  'handover.sections': 'sekcje: {count}',
  'handover.previous': 'Z poprzedniego przekazania',
  'handover.previousNone': 'Brak wcześniejszego przekazania tego kontenera.',
  'handover.previousPending': 'Do potwierdzenia: {count}',
  'handover.photograph': 'Stań na wprost i wypełnij kadr: {face}.',
  'handover.uploading': 'Rozmywanie twarzy i tablic, szukanie kontenera…',
  'handover.retake': 'Nowe zdjęcie',
  'handover.adjust': 'Popraw narożniki',
  'handover.adjustHint': 'Przeciągnij cztery punkty na narożniki: {face}.',
  'handover.cornersMissing': 'Nie znaleziono obrysu kontenera. Przeciągnij narożniki na miejsce.',
  'handover.addMark': 'Zaznacz uszkodzenie',
  'handover.addMarkHint': 'Obrysuj uszkodzenie prostokątem.',
  'handover.speakDamage': 'Powiedz uszkodzenie',
  'handover.speaking': 'Muse Voice słucha, Muse Spark koduje uszkodzenie…',
  'handover.spokenNone':
    'Nie usłyszano uszkodzenia z miejscem na kontenerze. Powiedz na przykład: „wgniecenie, lewy bok, sekcja trzecia, dół”.',
  'handover.unplaced': 'Powiedz, gdzie (ściana i sekcja): {items}',
  'handover.findDamage': 'Znajdź uszkodzenia',
  'handover.finding': 'Muse Spark szuka uszkodzeń, SAM 3.1 je obrysowuje…',
  'handover.found': 'Propozycje: {count}. Potwierdź lub odrzuć każdą poniżej.',
  'handover.noneFound': 'Na tym zdjęciu nie znaleziono nowych uszkodzeń.',
  'handover.reviewFirst': 'Przed zaplombowaniem potwierdź lub odrzuć proponowane uszkodzenia.',
  'handover.marks': 'Uszkodzenia w tym przekazaniu',
  'handover.noMarks': 'Nie zaznaczono uszkodzeń.',
  'handover.seal': 'Zaplombuj przekazanie',
  'handover.sealConfirm': 'Zaplombować to przekazanie? Później nie będzie można go zmienić.',
  'handover.sealed': 'Zapisano w historii kontenera',
  'handover.hash': 'Skrót rekordu',
  'handover.redacted': 'Rozmyte obszary (prywatność): {count}',

  'mark.damage': 'Uszkodzenie',
  'mark.component': 'Element',
  'mark.note': 'Uwagi',
  'mark.save': 'Zapisz uszkodzenie',
  'mark.stillThere': 'Nadal jest',
  'mark.changed': 'Zmienione',
  'mark.repaired': 'Naprawione',
  'mark.reject': 'Usuń',
  'mark.confirm': 'Potwierdź',
  'mark.proposed': 'Propozycja modeli',
  'mark.status.new': 'Nowe',
  'mark.status.still-there': 'Nadal jest',
  'mark.status.changed': 'Zmienione',
  'mark.status.repaired': 'Naprawione',
  'mark.resolved': 'Potwierdzone',

  'report.title': 'Protokół przekazania kontenera (EIR)',
  'report.print': 'Drukuj lub zapisz jako PDF',
  'report.open': 'Otwórz protokół EIR',
  'report.started': 'Rozpoczęcie oględzin',
  'report.sealedAt': 'Zaplombowano',
  'report.seal': 'Plomba',
  'report.chainPosition': 'Przekazanie nr {position} w historii kontenera',
  'report.chainOk': 'historia zweryfikowana, nienaruszona',
  'report.previousHash': 'Skrót poprzedniego rekordu',
  'report.notSealed': 'Jeszcze nie zaplombowano: to jest wersja robocza.',
  'report.comparison': 'Porównanie z poprzednim przekazaniem',
  'report.then': 'Poprzednie przekazanie',
  'report.now': 'To przekazanie',
  'report.recorded': 'Odnotowane',
  'report.notChecked': 'Nie sprawdzono',
  'report.newDamage': 'Nowe od poprzedniego przekazania',
  'report.damage': 'Uszkodzenia (ISO 9897 / CEDEX)',
  'report.location': 'Miejsce',
  'report.status': 'Stan',
  'report.firstRecorded': 'Zapisane po raz pierwszy',
  'report.here': 'Przy tym przekazaniu',
  'report.photos': 'Zdjęcia',
  'report.codeco': 'Komunikat EDIFACT CODECO',
  'report.codecoHint':
    'Komunikat wjazdu lub wyjazdu dla systemu armatora lub terminalu, z uszkodzeniami i skrótem tego rekordu.',
  'report.recipient': 'Identyfikator odbiorcy (np. kod EDI armatora)',
  'report.downloadCodeco': 'Pobierz CODECO',

  'dictate.start': 'Podyktuj uwagę',
  'dictate.stop': 'Zakończ nagrywanie',
  'dictate.working': 'Muse Voice przepisuje…',
  'dictate.denied': 'Mikrofon jest niedostępny.',
  'claim.title': 'Reklamacja uszkodzeń',
  'claim.draft': 'Przygotuj reklamację z Muse Spark',
  'claim.drafting': 'Muse Spark czyta rekordy i przygotowuje reklamację…',
  'claim.verified': 'Sprawdzono z zaplombowanymi rekordami',
  'claim.attempts':
    'Wersje napisane, zanim wszystkie kontrole przeszły: {count}. Użyte narzędzia: {tools}.',
  'claim.to': 'Do',
  'claim.subject': 'Temat',
  'claim.copy': 'Kopiuj pismo',
  'claim.copied': 'Skopiowano',
  'claim.check.items-are-new-damage':
    'Każda pozycja to uszkodzenie odnotowane jako nowe w tym zaplombowanym przekazaniu',
  'claim.check.codes-and-photos-match':
    'Miejsca, kody uszkodzeń i skróty SHA-256 zdjęć zgadzają się z rekordami',
  'claim.check.letter-cites-records':
    'Pismo podaje numer kontenera i skróty obu zaplombowanych rekordów',
  'access.title': 'Podaj kod dostępu',
  'access.hint':
    'Twoja organizacja ustawiła kod dla tej instalacji Plomby. Podajesz go raz na tym urządzeniu.',
  'access.code': 'Kod dostępu',
  'access.submit': 'Dalej',
  'live.searching': 'Szukam kontenera…',
  'live.ghosts': 'Na żywo: uszkodzenia z poprzedniego przekazania',
  'identify.why.verified': 'Cyfra kontrolna zgadza się z odczytem.',
  'identify.why.oneRepair':
    '„{read}” nie przechodzi kontroli cyfry kontrolnej. Zmiana {changes} dałaby poprawny numer: sprawdź te znaki na kontenerze.',
  'identify.why.modelChose':
    '„{read}” nie przechodzi kontroli cyfry kontrolnej, a poprawnych podobnych numerów jest {count}. Muse Spark po porównaniu ze zdjęciem proponuje pierwszy.',
  'identify.why.ambiguous':
    '„{read}” nie przechodzi kontroli cyfry kontrolnej, a {count} podobne numery są równie prawdopodobne.',
  'identify.why.noRepair':
    '„{read}” nie przechodzi kontroli cyfry kontrolnej i nie różni się od poprawnego numeru jednym ani dwoma podobnymi znakami.',
  'identify.why.nothing': 'Nie widać numeru kontenera. Sfotografuj drzwi na wprost.',
  'identify.change': '{from} → {to} (znak {position})',
  'identify.modelNote': 'Muse Spark',
  'error.validation': 'Żądanie nie zostało przyjęte',
  'error.unauthorized': 'Odmowa dostępu',
  'error.not-found': 'Nie znaleziono',
  'error.conflict': 'Teraz nie można tego zrobić',
  'error.upstream': 'Model nie odpowiedział poprawnie. Spróbuj ponownie.',
  'start.transport': 'Przyjechał lub odjeżdża',
  'start.road': 'Ciężarówką',
  'start.rail': 'Wagonem',
  'start.truck': 'Numer rejestracyjny',
  'start.wagon': 'Numer wagonu (UIC, 12 cyfr)',
  'start.wagonValid': 'poprawny numer UIC',
  'start.wagonDigits': '12 cyfr, ostatnia to cyfra kontrolna',
  'start.wagonExpected': 'Cyfra kontrolna powinna być {digit}',
  'handover.road': 'Ciężarówka {vehicle}',
  'handover.rail': 'Wagon {vehicle}',
  'passport.title': 'Paszport uszkodzeń',
  'passport.intro':
    'Wszystkie uszkodzenia zapisane na tym kontenerze, wyłącznie z zaplombowanych przekazań. Kolor oznacza przekazanie, w którym zapisano je po raz pierwszy.',
  'passport.mapLabel': 'Mapa ścian kontenera z zapisanymi uszkodzeniami',
  'passport.handover': '#{n} {direction} · {place} · {date}',
  'passport.none': 'Żadne zaplombowane przekazanie nie zapisało uszkodzeń.',
  'passport.firstRecorded': 'Zapisane po raz pierwszy: {handover}',
  'passport.lastClear': 'Nie było go przy: {handover}.',
  'passport.between': 'Powstało między tymi dwoma przekazaniami.',
  'passport.alreadyThere': 'Było już przy pierwszym zaplombowanym przekazaniu.',
  'passport.notInspected': 'Miejsce bez zdjęcia przy: {handovers}',
  'passport.recordedNearby':
    'Uszkodzenie w tym miejscu zapisano już przy: {handover}. Może to być to samo uszkodzenie.',
  'passport.broken':
    'Historia kontenera nie przechodzi weryfikacji, więc historia uszkodzeń nie jest pokazana.',
  'walk.title': 'Nagranie obchodu',
  'walk.intro':
    'Jedno nagranie z telefonu lub okularów Meta AI staje się zdjęciami tego przekazania. Zachowaj film przy przekazaniu jako zaplombowany dowód.',
  'walk.tip':
    'Zatrzymaj się na sekundę na wprost każdej ściany, na tyle daleko, by cała ściana mieściła się w kadrze.',
  'walk.samples': 'Albo wypróbuj przykładowy klip',
  'walk.loadingSample': 'Ładowanie przykładowego klipu…',
  'walk.sampleCredit': 'Przykładowy klip:',
  'walk.blankFrames':
    'Ta przeglądarka zwróciła puste klatki nagrania, więc nie da się rozpoznać ścian. Spróbuj ponownie albo użyj innej przeglądarki.',
  'walk.sideGuessed':
    'Lewa czy prawa to przypuszczenie: drzwi nie są widoczne. Sprawdź, po której stronie są.',
  'walk.how.track': 'SAM 3.1 śledzi kontener w każdej klatce',
  'walk.how.pick': 'Plomba wybiera klatki z całą ścianą i dzieli narożniki',
  'walk.how.name': 'Muse Spark nazywa ściany i odczytuje drzwi',
  'walk.how.confirm': 'Ty zatwierdzasz; klatki stają się zdjęciami',
  'walk.video': 'Wybierz wideo (MP4 lub MOV)',
  'walk.analyse': 'Przeanalizuj obchód',
  'walk.step.tracking': 'SAM 3.1 śledzi kontener w każdej klatce…',
  'walk.step.choosing': 'Wybieranie klatek, na których jedna ściana jest cała i na wprost…',
  'walk.step.naming': 'Muse Spark nazywa ścianę na każdej klatce…',
  'walk.step.reading': 'Muse Spark odczytuje drzwi…',
  'walk.summary':
    'Kontener znaleziony w klatkach: {tracked} z {total} · wybrane klatki: {candidates} · widoczne ściany: {faces}',
  'walk.cached': 'śledzenie z pamięci podręcznej',
  'walk.noFrames':
    'Żadna klatka nie pokazuje całej ściany kontenera. Nagraj ponownie z większej odległości, tak by każda ściana mieściła się w kadrze.',
  'walk.doorsMatch': 'Drzwi na nagraniu zgadzają się z przekazaniem:',
  'walk.doorsMismatch': 'Drzwi na nagraniu pokazują inny kontener:',
  'walk.doorsUnverified':
    'Nie udało się potwierdzić numeru z drzwi na nagraniu. Sprawdź go na drzwiach.',
  'walk.frames': 'Klatki wybrane z nagrania',
  'walk.frameAlt': 'Klatka {frame} nagrania',
  'walk.noFace': 'Brak jednej ściany',
  'walk.angled': 'pod kątem',
  'walk.unclear': 'nieostre lub zasłonięte',
  'walk.useAs.whole': 'Użyj jako zdjęcia',
  'walk.useAs.left': 'Lewa strona narożnika jako',
  'walk.useAs.right': 'Prawa strona narożnika jako',
  'walk.notUsed': 'Nie używaj',
  'walk.keepVideo': 'Zachowaj film przy przekazaniu',
  'walk.keepingVideo': 'Rozmywanie osób i tablic rejestracyjnych na filmie z obchodu…',
  'walk.findDamage': 'Szukaj uszkodzeń na każdym zdjęciu (Muse Spark i SAM 3.1)',
  'walk.add': 'Dodaj do przekazania (zdjęcia: {count})',
  'walk.adding': 'Dodawanie zdjęcia {n} z {total}: {face}…',
  'walk.lookingForDamage': 'Szukanie uszkodzeń: {face}…',
  'walk.frame': 'SAM 3.1 · klatka {frame} z {total}',
  'walk.lost': 'Nie znaleziono kontenera w tej klatce',
  'walk.label': 'Nagrane wideo, nie kamera na żywo',
  'handover.history': 'Historia kontenera',
  'handover.walkaround': 'Nagranie obchodu',
  'face.D': 'ściana drzwiowa',
  'face.R': 'prawa ściana',
  'face.F': 'ściana czołowa',
  'face.L': 'lewa ściana',
  'face.T': 'dach',
  'faceTitle.D': 'Drzwi',
  'faceTitle.R': 'Prawa',
  'faceTitle.F': 'Czoło',
  'faceTitle.L': 'Lewa',
  'faceTitle.T': 'Dach',
};
